
import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";

@Component({
  inject: [],
})
export default class ScrumSettings extends Vue {

  headers = [
    { text: "Action", value: 'meta.title' },
    { text: "Description", value: "meta.description" },
  ];
  private routes: Route[] = [];


  private created(): void {
    this.routes = [
      this.$router.resolve({ name: 'dev_scrum_components' }).resolved,
      this.$router.resolve({ name: 'create_component' }).resolved,
      this.$router.resolve({ name: 'all_audit' }).resolved,
    ];
    console.log(this.routes)

  }
}
